import { Inbox } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "requests",
  icon: Inbox,
  tabs: [{ to: "/requests", label: "nav.requests", perm: ["requests.request.create"] }],
  create: [{ label: "create.request", to: "/requests?new=1", perm: "requests.request.create" }],
  settings: { to: "/settings/requests", perm: ["requests.settings.read"] },
  setup: { first_request: "/requests?new=1" },
};
